import { CustomLightboxService } from './modules/stories/services/custom-lightbox.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslationService } from './services/translation.service';
import { environment } from 'src/environments/environment';
import { LanguageService } from './services/language.service';
import { Router } from '@angular/router';
import { ToastService } from './services/toast.service';
import { GenericLoginService } from './services/generic-login.service';
import { NotificationService } from './services/notification.service';
import { CrowdinOtaService } from './services/crowdin-ota/crowdin-ota.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    title = 'route';
    language = 'en-GB';
    translatedArray: any[] = [];
    showToast = false;
    toastMessage: any;
    toastType: any;
    position: any;
    leftPosition: any;
    noAnimation: boolean = false;
    featureFlags: any;
    @ViewChild('scrollElement') scrollElement: ElementRef | any;
    showLangPicker: boolean = false;
    showLoginForNonProdEnviorment: boolean = false;
    showLightBox: any;
    showNotification: boolean = false;

    constructor(
        private readonly translationService: TranslationService,
        private readonly languageService: LanguageService,
        private readonly router: Router,
        private toastService: ToastService,
        private genericLoginService: GenericLoginService,
        private lightboxService: CustomLightboxService,
        private readonly notificationService: NotificationService,
        private readonly _crowdinOtaService: CrowdinOtaService,
    ) {
        const fullURL = window.location.href.split('/');
        const languageIdFromUrl = window.location.href.split('/')[3];

        this.genericLoginService.getGenericLoginObservable().subscribe((value) => {
            this.showLoginForNonProdEnviorment =
                value !== true && !environment.production ? true : false;
        });

        if (languageService.checkIsValideLanguage(fullURL[3])) {
            localStorage.setItem('language', fullURL[3]);
        }

        const selectedLang = this.languageService.getLanguage();
        this.language = selectedLang;
        if (
            (languageIdFromUrl && languageService.checkIsValideLanguage(languageIdFromUrl)) ||
            fullURL.includes('logout') ||
            fullURL.includes('login') ||
            fullURL.some((url: string) => url.includes('login')) ||
            fullURL.includes('verify') ||
            fullURL.includes('anonymize') ||
            fullURL.includes('stories')
        ) {
            if (selectedLang) {
                this.language = selectedLang;
            } else {
                this.language = environment.supported_language[0];
                localStorage.setItem('language', this.language);
            }
        } else if (fullURL[3] !== '') {
            this.router.navigateByUrl('/' + this.language + '/404');
        } else if (fullURL[3] === '') {
            this.router.navigateByUrl('/' + this.language + '/home');
        }
    }

    async ngOnInit() {
        await this.translationService.getCustomerPortalConfiguration();
        await this._crowdinOtaService.initializeLanguage();
        this.featureFlags = this.translationService.featureFlags;
        this.getToastData();
        let videoStatus = sessionStorage.getItem('videoplayed');

        if (videoStatus === 'true') {
            this.noAnimation = true;
        }

        this.languageService.showLanguageSelectionPage$.subscribe((isShowLangPicker) => {
            this.showLangPicker = isShowLangPicker;
        });

        this.lightboxService.lightboxState$.subscribe((item) => {
            this.showLightBox = item.isOpen;
        });

        this.notificationService.notificationState$.subscribe((state) => {
            this.showNotification = state.isOpen;
        });

        this.translationService.getAllSupportedLanguages().subscribe((supportedLanguages: any) => {
            this.translationService.supportedLanguagesForDisplay = supportedLanguages;
        });
    }

    getToastData() {
        this.toastService.toastDetails.subscribe((status: any) => {
            this.showToast = status.isShown;
            this.toastMessage = status.message;
            this.toastType = status.toastType;
            this.position = status.position;
            this.leftPosition = status.leftPosition;
        });
    }

    scrollTop(event: any) {
        this.scrollElement.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
}
